import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SignatureCaseManager from "./SignatureCaseManager";
import PortfolioPackageManager from "./PortfolioPackageManager";
import ServiceManager from "./ServiceManager";
import ClientPortalManager from "./ClientPortalManager";
import "./admin.css";
import { useAdminAuth } from "../../contexts/AdminAuthContext";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const { logout } = useAdminAuth();
  const [activePanel, setActivePanel] = useState("signature");

  const handleSignOut = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className="admin-shell__sidebar">
        <div className="admin-shell__logo">Modelerman Admin</div>
        <nav className="admin-shell__nav">
          <button
            type="button"
            className={`admin-shell__nav-link admin-shell__nav-link--button${activePanel === "signature" ? " admin-shell__nav-link--active" : ""}`}
            onClick={() => setActivePanel("signature")}
          >
            Signature Projeler
          </button>
          <button
            type="button"
            className={`admin-shell__nav-link admin-shell__nav-link--button${activePanel === "packages" ? " admin-shell__nav-link--active" : ""}`}
            onClick={() => setActivePanel("packages")}
          >
            Portfolyo Paketleri
          </button>
          <button
            type="button"
            className={`admin-shell__nav-link admin-shell__nav-link--button${activePanel === "services" ? " admin-shell__nav-link--active" : ""}`}
            onClick={() => setActivePanel("services")}
          >
            Hizmetler
          </button>
          <button
            type="button"
            className={`admin-shell__nav-link admin-shell__nav-link--button${activePanel === "clients" ? " admin-shell__nav-link--active" : ""}`}
            onClick={() => setActivePanel("clients")}
          >
            Müşteri Portalı
          </button>
          <span className="admin-shell__nav-link" style={{ opacity: 0.4 }}>Eğitim Modülleri (yakında)</span>
          <span className="admin-shell__nav-link" style={{ opacity: 0.4 }}>Showreel (yakında)</span>
        </nav>
        <div style={{ marginTop: "auto", fontSize: "0.75rem", lineHeight: 1.6, color: "rgba(222, 227, 240, 0.48)" }}>
          <p style={{ margin: 0 }}>Supabase bağlantısı kurulduğunda gerçek zamanlı düzenleme ve kullanıcı yönetimi aktif hale gelecek.</p>
        </div>
      </aside>

      <main className="admin-shell__content">
        <div className="admin-shell__topbar">
          <button type="button" className="admin-shell__signout" onClick={handleSignOut}>
            Çıkış yap
          </button>
        </div>
        <header className="admin-shell__header">
          <h1 className="admin-shell__title">İçerik Kontrol Merkezi</h1>
          <p className="admin-shell__subtitle">
            Signature projeler, portfolyo paketleri ve diğer premium içerikleri tek panel üzerinden yönetin. Beta aşamasında olduğumuz için bazı modüller hâlâ hazırlık aşamasında.
          </p>
        </header>

        <div className="admin-shell__tabs">
          <button
            type="button"
            className={`admin-shell__tab${activePanel === "signature" ? " admin-shell__tab--active" : ""}`}
            onClick={() => setActivePanel("signature")}
          >
            Signature Portfolyo
          </button>
          <button
            type="button"
            className={`admin-shell__tab${activePanel === "packages" ? " admin-shell__tab--active" : ""}`}
            onClick={() => setActivePanel("packages")}
          >
            Portfolyo Paketleri
          </button>
          <button
            type="button"
            className={`admin-shell__tab${activePanel === "services" ? " admin-shell__tab--active" : ""}`}
            onClick={() => setActivePanel("services")}
          >
            Hizmetler
          </button>
          <button
            type="button"
            className={`admin-shell__tab${activePanel === "clients" ? " admin-shell__tab--active" : ""}`}
            onClick={() => setActivePanel("clients")}
          >
            Müşteri Portalı
          </button>
        </div>

        {activePanel === "signature" && <SignatureCaseManager />}
        {activePanel === "packages" && <PortfolioPackageManager />}
        {activePanel === "services" && <ServiceManager />}
        {activePanel === "clients" && <ClientPortalManager />}
      </main>
    </div>
  );
}
